var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "app-main-content policy-detail" }, [
    _c("div", { staticClass: "details-view" }, [
      _c(
        "div",
        { staticClass: "main-content", staticStyle: { "overflow-y": "unset" } },
        [
          _c(
            "div",
            { staticClass: "section", staticStyle: { padding: "0" } },
            [
              _c(
                "el-steps",
                { attrs: { active: _vm.active, simple: "" } },
                [
                  _c(
                    "el-step",
                    {
                      attrs: {
                        title: _vm.$t(
                          "Insurance.N1CompleteInsuranceInformation"
                        ),
                        icon: "1"
                      }
                    },
                    [
                      _c("div", { attrs: { slot: "title" }, slot: "title" }, [
                        _c("span", { staticClass: "index" }, [_vm._v("1")]),
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.$t("Insurance.CompleteInsuranceInformation")
                            )
                          )
                        ])
                      ])
                    ]
                  ),
                  _c(
                    "el-step",
                    {
                      attrs: { title: _vm.$t("Message.N2Inquiry"), icon: "2" }
                    },
                    [
                      _c("div", { attrs: { slot: "title" }, slot: "title" }, [
                        _c("span", { staticClass: "index" }, [_vm._v("2")]),
                        _c("span", [
                          _vm._v(_vm._s(_vm.$t("Insurance.Inquire")))
                        ])
                      ])
                    ]
                  ),
                  _c(
                    "el-step",
                    {
                      attrs: {
                        title: _vm.$t("Insurance.N3PreviewAndConfirm"),
                        icon: "3"
                      }
                    },
                    [
                      _c("div", { attrs: { slot: "title" }, slot: "title" }, [
                        _c("span", { staticClass: "index" }, [_vm._v("3")]),
                        _c("span", [
                          _vm._v(_vm._s(_vm.$t("Insurance.PreviewAndConfirm")))
                        ])
                      ])
                    ]
                  ),
                  _c(
                    "el-step",
                    {
                      attrs: {
                        title: _vm.$t("Message.N4InsuranceCompletion"),
                        icon: "4"
                      }
                    },
                    [
                      _c("div", { attrs: { slot: "title" }, slot: "title" }, [
                        _c("span", { staticClass: "index" }, [_vm._v("4")]),
                        _c("span", [
                          _vm._v(_vm._s(_vm.$t("Insurance.InsuranceCompleted")))
                        ])
                      ])
                    ]
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-form",
            {
              attrs: {
                inline: "",
                "label-position": "left",
                "label-width": "200px"
              }
            },
            [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.active === 0 || _vm.active === 2,
                      expression: "active === 0 || active === 2"
                    }
                  ]
                },
                [
                  _c(
                    "div",
                    [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                _vm.form.cancelReason != "" &&
                                _vm.form.cancelReason != null &&
                                _vm.viewSource === "manage",
                              expression:
                                "form.cancelReason !='' && form.cancelReason!=null && viewSource === 'manage'"
                            }
                          ],
                          staticClass: "section header"
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("Insurance.CancellationReason")) +
                              " "
                          )
                        ]
                      ),
                      _c(
                        "el-form-item",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                _vm.form.cancelReason != "" &&
                                _vm.form.cancelReason != null &&
                                _vm.viewSource === "manage",
                              expression:
                                "form.cancelReason !='' && form.cancelReason!=null && viewSource === 'manage'"
                            }
                          ],
                          attrs: { label: "", required: "" }
                        },
                        [
                          _c("span", { staticClass: "input-content" }, [
                            _vm._v(_vm._s(_vm.form.cancelReason))
                          ])
                        ]
                      ),
                      _c("div", { staticClass: "section header" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t("Insurance.PolicyHolderInformation")
                            ) +
                            " "
                        )
                      ]),
                      _c(
                        "div",
                        { staticClass: "content" },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("Insurance.Insured"),
                                required: ""
                              }
                            },
                            [
                              _c(
                                "div",
                                { staticStyle: { display: "flex" } },
                                [
                                  _c("cargo-company-select", {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: !_vm.form.sameApplicant,
                                        expression: "!form.sameApplicant"
                                      }
                                    ],
                                    staticClass: "input-content",
                                    attrs: {
                                      "select-type":
                                        _vm.selectTypeNames.basic_data_Company,
                                      "method-params": { active: true },
                                      "default-value":
                                        _vm.form.insuredIdx || "",
                                      disabled: _vm.disableFlag
                                    },
                                    on: {
                                      change: function(p) {
                                        _vm.form.insuredIdx = p.value
                                      }
                                    }
                                  }),
                                  _c(
                                    "span",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.form.sameApplicant,
                                          expression: "form.sameApplicant"
                                        }
                                      ],
                                      staticClass: "input-content",
                                      attrs: { disabled: "true" }
                                    },
                                    [
                                      _vm._v(
                                        " " + _vm._s(_vm.form.applicantName)
                                      )
                                    ]
                                  ),
                                  _c(
                                    "el-checkbox",
                                    {
                                      staticStyle: { "margin-left": "10px" },
                                      attrs: { disabled: _vm.disableFlag },
                                      on: {
                                        change: function($event) {
                                          return _vm.toAppNameFunc()
                                        }
                                      },
                                      model: {
                                        value: _vm.form.sameApplicant,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "sameApplicant",
                                            $$v
                                          )
                                        },
                                        expression: "form.sameApplicant"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("Insurance.SameAsPolicyHolder")
                                        )
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ]
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("Insurance.PolicyHolder"),
                                required: ""
                              }
                            },
                            [
                              _c("span", { staticClass: "input-content" }, [
                                _vm._v(_vm._s(_vm.form.applicantName))
                              ])
                            ]
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("Insurance.EmailRecipient"),
                                required: ""
                              }
                            },
                            [
                              _c("cargo-advance-select", {
                                staticClass: "input-content",
                                attrs: {
                                  filterable: "",
                                  "allow-create": "",
                                  multiple: "",
                                  disabled: _vm.disableFlag,
                                  "default-multiple-value":
                                    _vm.multipleEmailArray,
                                  cache: false,
                                  "tag-name": "emailReceivers",
                                  "tag-value": "emailReceivers",
                                  "filter-tag-names": ["emailReceivers"],
                                  "static-options": _vm.emailArray
                                },
                                on: { parentCallBack: _vm.getEmailReceviers }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c("div", [
                    _c("div", { staticClass: "section header" }, [
                      _vm._v(
                        " " + _vm._s(_vm.$t("Insurance.GoodsInformation")) + " "
                      )
                    ]),
                    _c(
                      "div",
                      { staticClass: "content" },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("Insurance.GoodsCategory"),
                              required: ""
                            }
                          },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "600px" },
                                attrs: {
                                  filterable: "",
                                  disabled: _vm.disableFlag
                                },
                                model: {
                                  value: _vm.form.goodsCategoryCode,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "goodsCategoryCode", $$v)
                                  },
                                  expression: "form.goodsCategoryCode"
                                }
                              },
                              _vm._l(_vm.goodsCategoryArray, function(item) {
                                return _c("el-option", {
                                  key: item.code,
                                  attrs: {
                                    label: item.descEN,
                                    value: item.code
                                  }
                                })
                              }),
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("Insurance.GoodsName"),
                              disabled: _vm.disableFlag,
                              required: ""
                            }
                          },
                          [
                            _c("el-input", {
                              staticClass: "input-content",
                              attrs: {
                                disabled: _vm.disableFlag,
                                type: "textarea",
                                rows: 5
                              },
                              model: {
                                value: _vm.form.goodsName,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "goodsName", $$v)
                                },
                                expression: "form.goodsName"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("Insurance.MarksAndNumbers")
                            }
                          },
                          [
                            _c("el-input", {
                              staticClass: "input-content",
                              attrs: {
                                disabled: _vm.disableFlag,
                                type: "textarea",
                                rows: 5
                              },
                              model: {
                                value: _vm.form.shippingMarks,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "shippingMarks", $$v)
                                },
                                expression: "form.shippingMarks"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("Insurance.BillOfLadingNumber")
                            }
                          },
                          [
                            _c("el-input", {
                              staticClass: "input-content",
                              attrs: { disabled: _vm.disableFlag },
                              model: {
                                value: _vm.form.blNo,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "blNo", $$v)
                                },
                                expression: "form.blNo"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("Insurance.BillOfLadingDate")
                            }
                          },
                          [
                            _c("el-date-picker", {
                              staticClass: "input-content",
                              attrs: { disabled: _vm.disableFlag },
                              model: {
                                value: _vm.form.blDate,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "blDate", $$v)
                                },
                                expression: "form.blDate"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("Insurance.InvoiceNumber"),
                              required: ""
                            }
                          },
                          [
                            _c("el-input", {
                              staticClass: "input-content",
                              attrs: { disabled: _vm.disableFlag },
                              model: {
                                value: _vm.form.invoiceNo,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "invoiceNo", $$v)
                                },
                                expression: "form.invoiceNo"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: { label: _vm.$t("Insurance.ContractNumber") }
                          },
                          [
                            _c("el-input", {
                              staticClass: "input-content",
                              attrs: { disabled: _vm.disableFlag },
                              model: {
                                value: _vm.form.contractNo,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "contractNo", $$v)
                                },
                                expression: "form.contractNo"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]),
                  _c("div", [
                    _c("div", { staticClass: "section header" }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$t("Insurance.TransportationInformation")
                          ) +
                          " "
                      )
                    ]),
                    _c(
                      "div",
                      { staticClass: "content" },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t(
                                "Insurance.VesselVoyagevehiclePlateNumberflightNumber"
                              ),
                              required: ""
                            }
                          },
                          [
                            _c("el-input", {
                              staticClass: "input-content",
                              attrs: { disabled: _vm.disableFlag },
                              model: {
                                value: _vm.form.conveyance,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "conveyance", $$v)
                                },
                                expression: "form.conveyance"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              disabled: _vm.disableFlag,
                              label: _vm.$t("Insurance.TransportationType"),
                              required: ""
                            },
                            model: {
                              value: _vm.form.voyageMode,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "voyageMode", $$v)
                              },
                              expression: "form.voyageMode"
                            }
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "input-content" },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticClass: "input-content",
                                    attrs: {
                                      filterable: "",
                                      disabled: _vm.disableFlag
                                    },
                                    model: {
                                      value: _vm.form.voyageMode,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "voyageMode", $$v)
                                      },
                                      expression: "form.voyageMode"
                                    }
                                  },
                                  [
                                    _c("el-option", {
                                      attrs: {
                                        label: _vm.$t("Insurance.Domestic"),
                                        value: "01"
                                      }
                                    }),
                                    _c("el-option", {
                                      attrs: {
                                        label: _vm.$t("Insurance.Import"),
                                        value: "02"
                                      }
                                    }),
                                    _c("el-option", {
                                      attrs: {
                                        label: _vm.$t("Insurance.Export"),
                                        value: "03"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ]
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("Insurance.TransportationMode"),
                              required: ""
                            }
                          },
                          [
                            _c(
                              "el-radio-group",
                              {
                                staticStyle: { width: "700px" },
                                attrs: { disabled: _vm.disableFlag },
                                model: {
                                  value: _vm.form.conveyanceType,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "conveyanceType", $$v)
                                  },
                                  expression: "form.conveyanceType"
                                }
                              },
                              [
                                _c("el-radio", { attrs: { label: "1" } }, [
                                  _vm._v("Sea")
                                ]),
                                _c("el-radio", { attrs: { label: "2" } }, [
                                  _vm._v("Land")
                                ]),
                                _c("el-radio", { attrs: { label: "3" } }, [
                                  _vm._v("Air")
                                ]),
                                _c("el-radio", { attrs: { label: "4" } }, [
                                  _vm._v("Parcel Post / Courier")
                                ])
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t(
                                "Insurance.InlandTransportationTools"
                              )
                            }
                          },
                          [
                            _c("el-input", {
                              staticClass: "input-content",
                              attrs: { disabled: _vm.disableFlag },
                              model: {
                                value: _vm.form.voyagepreWay,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "voyagepreWay", $$v)
                                },
                                expression: "form.voyagepreWay"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("Insurance.PlaceOfDepartureport"),
                              required: ""
                            }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  display: "flex",
                                  "justify-content": "space-between"
                                }
                              },
                              [
                                _c("cargo-advance-select", {
                                  staticClass: "input-content",
                                  attrs: {
                                    disabled: _vm.disableFlag,
                                    "select-type":
                                      _vm.form.jobLob === "SE" ||
                                      _vm.form.jobLob === "SI"
                                        ? _vm.selectTypeNames.basic_data_Seaport
                                        : _vm.selectTypeNames
                                            .basic_data_Airport,
                                    filterable: "",
                                    "default-value": _vm.form.fromHaulway
                                  },
                                  on: {
                                    parentCallBack: function(p) {
                                      _vm.form.fromHaulway = p.value
                                    }
                                  }
                                })
                              ],
                              1
                            )
                          ]
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("Insurance.DepartureDate"),
                              required: ""
                            }
                          },
                          [
                            _c("el-date-picker", {
                              staticClass: "input-content",
                              attrs: {
                                disabled: _vm.disableFlag,
                                "picker-options": _vm.pickerOptions
                              },
                              model: {
                                value: _vm.form.inceptionDate,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "inceptionDate", $$v)
                                },
                                expression: "form.inceptionDate"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("Insurance.TransitPlaceport")
                            }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  display: "flex",
                                  "justify-content": "space-between"
                                }
                              },
                              [
                                _c("cargo-advance-select", {
                                  staticClass: "input-content",
                                  attrs: {
                                    multiple: "",
                                    filterable: "",
                                    "select-type":
                                      _vm.form.jobLob === "SE" ||
                                      _vm.form.jobLob === "SI"
                                        ? _vm.selectTypeNames.basic_data_Seaport
                                        : _vm.selectTypeNames
                                            .basic_data_Airport,
                                    "default-multiple-value":
                                      _vm.multipleTransportArray,
                                    disabled: _vm.disableFlag
                                  },
                                  on: { parentCallBack: _vm.getTransPortArray }
                                })
                              ],
                              1
                            )
                          ]
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("Insurance.Destinationport"),
                              required: ""
                            }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  display: "flex",
                                  "justify-content": "space-between"
                                }
                              },
                              [
                                _c("cargo-advance-select", {
                                  staticClass: "input-content",
                                  attrs: {
                                    disabled: _vm.disableFlag,
                                    "select-type":
                                      _vm.form.jobLob === "SE" ||
                                      _vm.form.jobLob === "SI"
                                        ? _vm.selectTypeNames.basic_data_Seaport
                                        : _vm.selectTypeNames
                                            .basic_data_Airport,
                                    filterable: "",
                                    "default-value": _vm.form.toHaulway
                                  },
                                  on: {
                                    parentCallBack: function(p) {
                                      _vm.form.toHaulway = p.value
                                    }
                                  }
                                })
                              ],
                              1
                            )
                          ]
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("Insurance.InlandStartingPoint")
                            }
                          },
                          [
                            _c("el-input", {
                              staticClass: "input-content",
                              attrs: { disabled: _vm.disableFlag },
                              model: {
                                value: _vm.form.departureInland,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "departureInland", $$v)
                                },
                                expression: "form.departureInland"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("Insurance.TradeTerms"),
                              required: ""
                            }
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "input-content" },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticClass: "input-content",
                                    attrs: {
                                      filterable: "",
                                      disabled: _vm.disableFlag
                                    },
                                    model: {
                                      value: _vm.form.upliftType,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "upliftType", $$v)
                                      },
                                      expression: "form.upliftType"
                                    }
                                  },
                                  [
                                    _c("el-option", {
                                      attrs: { label: "EXW", value: "UT01" }
                                    }),
                                    _c("el-option", {
                                      attrs: { label: "FCA", value: "UT02" }
                                    }),
                                    _c("el-option", {
                                      attrs: { label: "FAS", value: "UT03" }
                                    }),
                                    _c("el-option", {
                                      attrs: { label: "FOB", value: "UT04" }
                                    }),
                                    _c("el-option", {
                                      attrs: { label: "CFR", value: "UT05" }
                                    }),
                                    _c("el-option", {
                                      attrs: { label: "C&F", value: "UT06" }
                                    }),
                                    _c("el-option", {
                                      attrs: { label: "CIF", value: "UT07" }
                                    }),
                                    _c("el-option", {
                                      attrs: { label: "CPT", value: "UT08" }
                                    }),
                                    _c("el-option", {
                                      attrs: { label: "CIP", value: "UT09" }
                                    }),
                                    _c("el-option", {
                                      attrs: { label: "DAF", value: "UT10" }
                                    }),
                                    _c("el-option", {
                                      attrs: { label: "DAT", value: "UT11" }
                                    }),
                                    _c("el-option", {
                                      attrs: { label: "DAP", value: "UT12" }
                                    }),
                                    _c("el-option", {
                                      attrs: { label: "DES", value: "UT13" }
                                    }),
                                    _c("el-option", {
                                      attrs: { label: "DEQ", value: "UT14" }
                                    }),
                                    _c("el-option", {
                                      attrs: { label: "DDU", value: "UT15" }
                                    }),
                                    _c("el-option", {
                                      attrs: { label: "DDP", value: "UT16" }
                                    }),
                                    _c("el-option", {
                                      attrs: {
                                        label: "Invoice Value",
                                        value: "UT17"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ]),
                  _c("div", [
                    _c("div", { staticClass: "section header" }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$t("Insurance.InsuranceAmountInformation")
                          ) +
                          " "
                      )
                    ]),
                    _c(
                      "div",
                      { staticClass: "content" },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("Insurance.InvoiceAmount"),
                              required: ""
                            }
                          },
                          [
                            _c(
                              "div",
                              { staticStyle: { display: "flex" } },
                              [
                                _c("el-input", {
                                  staticClass: "input-content",
                                  attrs: {
                                    disabled: _vm.disableFlag,
                                    type: "number"
                                  },
                                  model: {
                                    value: _vm.form.invoiceAmount,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "invoiceAmount", $$v)
                                    },
                                    expression: "form.invoiceAmount"
                                  }
                                }),
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { width: "600px" },
                                    attrs: {
                                      disabled: _vm.disableFlag,
                                      filterable: ""
                                    },
                                    model: {
                                      value: _vm.form.currency,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "currency", $$v)
                                      },
                                      expression: "form.currency"
                                    }
                                  },
                                  _vm._l(_vm.currencyArray, function(item) {
                                    return _c("el-option", {
                                      key: item.code,
                                      attrs: {
                                        label: item.NAME,
                                        value: item.code
                                      }
                                    })
                                  }),
                                  1
                                )
                              ],
                              1
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ]),
                  _c("div", [
                    _c("div", { staticClass: "section header" }, [
                      _vm._v(
                        " " +
                          _vm._s(_vm.$t("Insurance.InsuranceConditions")) +
                          " "
                      )
                    ]),
                    _c(
                      "div",
                      { staticClass: "content" },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("Insurance.MainInsurance"),
                              required: ""
                            }
                          },
                          [
                            _c(
                              "el-radio-group",
                              {
                                attrs: { disabled: _vm.disableFlag },
                                model: {
                                  value: _vm.form.mainType,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "mainType", $$v)
                                  },
                                  expression: "form.mainType"
                                }
                              },
                              [
                                _c("el-radio", { attrs: { label: "01" } }, [
                                  _vm._v(
                                    _vm._s(_vm.$t("Insurance.FreightInsurance"))
                                  )
                                ]),
                                _c(
                                  "el-radio",
                                  { attrs: { label: "02", disabled: "true" } },
                                  [_vm._v(_vm._s(_vm.$t("Insurance.WPA")))]
                                ),
                                _c(
                                  "el-radio",
                                  { attrs: { label: "03", disabled: "true" } },
                                  [_vm._v(_vm._s(_vm.$t("Insurance.FPA")))]
                                ),
                                _c(
                                  "el-radio",
                                  { attrs: { label: "04", disabled: "true" } },
                                  [_vm._v("I.C.C.(A)")]
                                ),
                                _c(
                                  "el-radio",
                                  { attrs: { label: "05", disabled: "true" } },
                                  [_vm._v("I.C.C.(B)")]
                                ),
                                _c(
                                  "el-radio",
                                  { attrs: { label: "06", disabled: "true" } },
                                  [_vm._v("I.C.C.(C)")]
                                ),
                                _c(
                                  "el-radio",
                                  { attrs: { label: "07", disabled: "true" } },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "Insurance.AllRiskForRefrigeratedGoods"
                                        )
                                      )
                                    )
                                  ]
                                ),
                                _c(
                                  "el-radio",
                                  { attrs: { label: "08", disabled: "true" } },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "Insurance.RefrigeratedInsurance"
                                        )
                                      )
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t(
                                "Message.NumberOfPiecescommissionactual"
                              )
                            }
                          },
                          [
                            _c("el-input", {
                              staticClass: "input-content",
                              attrs: { disabled: _vm.disableFlag },
                              model: {
                                value: _vm.form.lcConditions,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "lcConditions", $$v)
                                },
                                expression: "form.lcConditions"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t(
                                "Insurance.LetterOfCreditConditionNumber"
                              )
                            }
                          },
                          [
                            _c("el-input", {
                              staticClass: "input-content",
                              attrs: { disabled: _vm.disableFlag },
                              model: {
                                value: _vm.form.lcNo,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "lcNo", $$v)
                                },
                                expression: "form.lcNo"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]),
                  _c("div", [
                    _c("div", { staticClass: "section header" }, [
                      _vm._v(
                        " " + _vm._s(_vm.$t("Insurance.OtherInformation")) + " "
                      )
                    ]),
                    _c(
                      "div",
                      { staticClass: "content" },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("Insurance.ClaimsAgentPoint"),
                              required: ""
                            }
                          },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "400px" },
                                attrs: { disabled: _vm.disableFlag },
                                model: {
                                  value: _vm.form.claimagentCode,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "claimagentCode", $$v)
                                  },
                                  expression: "form.claimagentCode"
                                }
                              },
                              _vm._l(_vm.claimAgentArray, function(item) {
                                return _c("el-option", {
                                  key: item.code,
                                  attrs: { label: item.desc, value: item.code }
                                })
                              }),
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.active === 2,
                                expression: "active === 2"
                              }
                            ]
                          },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t("Insurance.Premium"),
                                  required: ""
                                }
                              },
                              [
                                _c("span", { staticClass: "input-content" }, [
                                  _vm._v(_vm._s(_vm.form.premium))
                                ]),
                                _c("span", { staticClass: "input-content" }, [
                                  _vm._v(_vm._s(_vm.form.currency))
                                ])
                              ]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.active === 0,
                          expression: "active === 0"
                        }
                      ]
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "section header",
                          staticStyle: { "background-color": "red" }
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t("Insurance.InsuranceInstructions")
                              ) +
                              " "
                          )
                        ]
                      ),
                      _c(
                        "div",
                        { staticStyle: { width: "1100px", margin: "0 auto" } },
                        [
                          _c(
                            "el-checkbox",
                            {
                              staticClass: "el-checkbox__input",
                              model: {
                                value: _vm.isAgree,
                                callback: function($$v) {
                                  _vm.isAgree = $$v
                                },
                                expression: "isAgree"
                              }
                            },
                            [
                              _c("p", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("Insurance.InsuranceInstructionsTip")
                                  )
                                )
                              ]),
                              _c("p", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "Insurance.TheInstitutionsWithTechnicalLtd"
                                    )
                                  )
                                )
                              ])
                            ]
                          )
                        ],
                        1
                      )
                    ]
                  )
                ]
              ),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.active === 1,
                      expression: "active === 1"
                    }
                  ]
                },
                [
                  _c("div", { staticClass: "section header" }, [
                    _vm._v(
                      " " + _vm._s(_vm.$t("Insurance.PremiumAmount")) + " "
                    )
                  ]),
                  _c(
                    "div",
                    { staticClass: "content" },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("Insurance.Insured2") } },
                        [
                          _c(
                            "div",
                            { staticStyle: { display: "flex" } },
                            [
                              _c("cargo-company-select", {
                                staticClass: "input-content",
                                attrs: {
                                  "select-type":
                                    _vm.selectTypeNames.basic_data_Company,
                                  "method-params": { active: true },
                                  "default-value": _vm.form.insuredIdx || "",
                                  disabled: true
                                },
                                on: {
                                  change: function(p) {
                                    _vm.form.insuredIdx = p.value
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ]
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("Insurance.PolicyHolder") } },
                        [
                          _c("span", { staticClass: "input-content" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "Insurance.ShanghaiStorageAndTransportationLtd"
                                )
                              )
                            )
                          ])
                        ]
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("Insurance.InsuranceStartDate")
                          }
                        },
                        [
                          _c("el-date-picker", {
                            staticClass: "input-content",
                            attrs: { disabled: true },
                            model: {
                              value: _vm.form.inceptionDate,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "inceptionDate", $$v)
                              },
                              expression: "form.inceptionDate"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("Insurance.EndDateOfInsurance")
                          }
                        },
                        [
                          _c("el-date-picker", {
                            staticClass: "input-content",
                            attrs: { disabled: true },
                            model: {
                              value: _vm.form.terminationDate,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "terminationDate", $$v)
                              },
                              expression: "form.terminationDate"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("Insurance.DateOfInsurance") }
                        },
                        [
                          _c("el-date-picker", {
                            staticClass: "input-content",
                            attrs: { disabled: true },
                            model: {
                              value: _vm.form.applicationDate,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "applicationDate", $$v)
                              },
                              expression: "form.applicationDate"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("Insurance.DateOfEntry") } },
                        [
                          _c("el-date-picker", {
                            staticClass: "input-content",
                            attrs: { disabled: true },
                            model: {
                              value: _vm.form.inputDate,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "inputDate", $$v)
                              },
                              expression: "form.inputDate"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("Insurance.MainClause") } },
                        [
                          _c("el-input", {
                            staticClass: "input-content",
                            attrs: { disabled: true },
                            model: {
                              value: _vm.form.mainClauseCode,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "mainClauseCode", $$v)
                              },
                              expression: "form.mainClauseCode"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("Insurance.GoodsName2") } },
                        [
                          _c("el-input", {
                            staticStyle: { width: "300px" },
                            attrs: {
                              type: "textarea",
                              rows: 5,
                              disabled: true
                            },
                            model: {
                              value: _vm.form.goodsName,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "goodsName", $$v)
                              },
                              expression: "form.goodsName"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("Insurance.InsurancePremium") }
                        },
                        [
                          _c("el-input", {
                            staticClass: "input-content",
                            attrs: { disabled: true },
                            model: {
                              value: _vm.form.premium + " " + _vm.form.currency,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.form.premium + " " + _vm.form,
                                  "currency",
                                  $$v
                                )
                              },
                              expression: "form.premium + ' ' + form.currency"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("Insurance.InsuranceAmounttotalLimit")
                          }
                        },
                        [
                          _c("el-input", {
                            staticClass: "input-content",
                            attrs: { disabled: true },
                            model: {
                              value:
                                _vm.form.insuranceAmount +
                                " " +
                                _vm.form.currency,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.form.insuranceAmount + " " + _vm.form,
                                  "currency",
                                  $$v
                                )
                              },
                              expression:
                                "form.insuranceAmount + ' ' + form.currency"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("Insurance.FinalRate") } },
                        [
                          _c("el-input", {
                            staticClass: "input-content",
                            attrs: { disabled: true },
                            model: {
                              value: _vm.form.finalRate,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "finalRate", $$v)
                              },
                              expression: "form.finalRate"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("Insurance.AddProportion") } },
                        [
                          _c("el-input", {
                            staticClass: "input-content",
                            attrs: { disabled: true },
                            model: {
                              value: _vm.form.additionProportion,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "additionProportion", $$v)
                              },
                              expression: "form.additionProportion"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
              ),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.active === 3,
                      expression: "active === 3"
                    }
                  ]
                },
                [
                  _vm.isSuccess
                    ? _c(
                        "div",
                        {
                          staticStyle: {
                            "margin-top": "50px",
                            "text-align": "center"
                          }
                        },
                        [
                          _c("el-icon", {
                            staticClass: "el-icon-check",
                            staticStyle: {
                              color: "greenyellow",
                              "font-size": "45px"
                            }
                          }),
                          _c("span", { staticStyle: { "font-size": "35px" } }, [
                            _vm._v(
                              _vm._s(_vm.$t("Insurance.SuccessfullyInsured"))
                            )
                          ])
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        "margin-top": "50px",
                        "text-align": "center"
                      }
                    },
                    [
                      _c("el-form-item", [
                        _c("div", { staticStyle: { display: "flex" } }, [
                          _c("span", { staticStyle: { "font-size": "15px" } }, [
                            _vm._v(_vm._s(_vm.$t("Insurance.PolicyNumber")))
                          ]),
                          _c(
                            "span",
                            {
                              staticStyle: {
                                color: "blue",
                                "text-decoration": "underline",
                                cursor: "pointer",
                                "margin-left": "10px",
                                "font-size": "15px"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.toManagement()
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.form.policyNo))]
                          )
                        ])
                      ])
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "content" },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("Insurance.Insured2") } },
                        [
                          _c(
                            "div",
                            { staticStyle: { display: "flex" } },
                            [
                              _c("cargo-company-select", {
                                staticClass: "input-content",
                                attrs: {
                                  "select-type":
                                    _vm.selectTypeNames.basic_data_Company,
                                  "method-params": { active: true },
                                  "default-value": _vm.form.insuredIdx || "",
                                  disabled: _vm.disableFlag
                                },
                                on: {
                                  change: function(p) {
                                    _vm.form.insuredIdx = p.value
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ]
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("Insurance.PolicyHolder") } },
                        [
                          _c("span", { staticClass: "input-content" }, [
                            _vm._v(" " + _vm._s(_vm.form.applicantName))
                          ])
                        ]
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "Insurance.InsuranceApplicationNumber"
                            )
                          }
                        },
                        [
                          _c("el-input", {
                            staticClass: "input-content",
                            staticStyle: { color: "blue" },
                            attrs: { disabled: true },
                            model: {
                              value: _vm.form.applicationNo,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "applicationNo", $$v)
                              },
                              expression: "form.applicationNo"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("Insurance.PolicyStatus") } },
                        [
                          _c(
                            "div",
                            { staticClass: "input-content" },
                            [
                              _c("el-input", {
                                staticClass: "input-content",
                                staticStyle: { color: "blue" },
                                attrs: { disabled: true },
                                model: {
                                  value: _vm.form.policyStatusDescription,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.form,
                                      "policyStatusDescription",
                                      $$v
                                    )
                                  },
                                  expression: "form.policyStatusDescription"
                                }
                              })
                            ],
                            1
                          )
                        ]
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("Insurance.InsuranceStartDate")
                          }
                        },
                        [
                          _c("el-date-picker", {
                            staticClass: "input-content",
                            attrs: { disabled: true },
                            model: {
                              value: _vm.form.inceptionDate,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "inceptionDate", $$v)
                              },
                              expression: "form.inceptionDate"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("Insurance.EndDateOfInsurance")
                          }
                        },
                        [
                          _c("el-date-picker", {
                            staticClass: "input-content",
                            attrs: { disabled: true },
                            model: {
                              value: _vm.form.terminationDate,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "terminationDate", $$v)
                              },
                              expression: "form.terminationDate"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("Insurance.DateOfInsurance") }
                        },
                        [
                          _c("el-date-picker", {
                            staticClass: "input-content",
                            attrs: { disabled: true },
                            model: {
                              value: _vm.form.applicationDate,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "applicationDate", $$v)
                              },
                              expression: "form.applicationDate"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("Insurance.DateOfEntry") } },
                        [
                          _c("el-date-picker", {
                            staticClass: "input-content",
                            attrs: { disabled: true },
                            model: {
                              value: _vm.form.inputDate,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "inputDate", $$v)
                              },
                              expression: "form.inputDate"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("Insurance.ReviewDate") } },
                        [
                          _c("el-date-picker", {
                            staticClass: "input-content",
                            attrs: { disabled: true },
                            model: {
                              value: _vm.form.checkDate,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "checkDate", $$v)
                              },
                              expression: "form.checkDate"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("Insurance.UnderwritingDate") }
                        },
                        [
                          _c("el-date-picker", {
                            staticClass: "input-content",
                            attrs: { disabled: true },
                            model: {
                              value: _vm.form.underwritingDate,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "underwritingDate", $$v)
                              },
                              expression: "form.underwritingDate"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("Insurance.MainClause") } },
                        [
                          _c("el-input", {
                            staticClass: "input-content",
                            attrs: { disabled: true },
                            model: {
                              value: _vm.form.mainClauseCode,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "mainClauseCode", $$v)
                              },
                              expression: "form.mainClauseCode"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("Insurance.GoodsName2") } },
                        [
                          _c("el-input", {
                            staticClass: "input-content",
                            attrs: { disabled: true },
                            model: {
                              value: _vm.form.goodsName,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "goodsName", $$v)
                              },
                              expression: "form.goodsName"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("Insurance.InsurancePremium") }
                        },
                        [
                          _c("el-input", {
                            staticClass: "input-content",
                            attrs: { disabled: true },
                            model: {
                              value: _vm.form.premium + " " + _vm.form.currency,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.form.premium + " " + _vm.form,
                                  "currency",
                                  $$v
                                )
                              },
                              expression: "form.premium+' '+form.currency"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("Insurance.InsuranceAmounttotalLimit")
                          }
                        },
                        [
                          _c("el-input", {
                            staticClass: "input-content",
                            attrs: { disabled: true },
                            model: {
                              value:
                                _vm.form.insuranceAmount +
                                " " +
                                _vm.form.currency,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.form.insuranceAmount + " " + _vm.form,
                                  "currency",
                                  $$v
                                )
                              },
                              expression:
                                "form.insuranceAmount+' '+form.currency"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("Insurance.FinalRate") } },
                        [
                          _c("el-input", {
                            staticClass: "input-content",
                            attrs: { disabled: true },
                            model: {
                              value: _vm.form.finalRate,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "finalRate", $$v)
                              },
                              expression: "form.finalRate"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("Insurance.AddProportion") } },
                        [
                          _c("el-input", {
                            staticClass: "input-content",
                            attrs: { disabled: true },
                            model: {
                              value: _vm.form.additionProportion,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "additionProportion", $$v)
                              },
                              expression: "form.additionProportion"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
              )
            ]
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "button" },
        [
          _vm.active === 0
            ? _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.temporaryStorage }
                },
                [_vm._v(_vm._s(_vm.$t("Insurance.TemporarySave")))]
              )
            : _vm._e(),
          _vm.active === 0
            ? _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.toPreStep(1, 1, false)
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("Insurance.Inquire")))]
              )
            : _vm._e(),
          _vm.active === 1
            ? _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.toPreStep(2, 0, true)
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("Insurance.PreviewAndContinue")))]
              )
            : _vm._e(),
          _vm.active === 1
            ? _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.toPreStep(0, 0, false)
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("Insurance.Back")))]
              )
            : _vm._e(),
          _vm.active === 2 && _vm.viewSource != "manage"
            ? _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.insure()
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("Insurance.PurchaseInsurance")))]
              )
            : _vm._e(),
          _vm.active === 2
            ? _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.toPreStep(1, 0, true)
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("Insurance.Back")))]
              )
            : _vm._e()
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }